export default __webpack_public_path__ + "static/media/youtube-entertainment.668be135.png";